import { Image } from "react-bootstrap";
import { handleKeyboardClick } from "../../../utils/keyboardUtils";

const CarouselItem = ({
    src,
    ariaLabel,
    alt,
    onClick = () => {},
    className = "",
    index,
    total,
}) => {
    if (!src) throw new Error("src is required");
    return (
      <div
        role="img"
        aria-label={ariaLabel || alt || ""}
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
        onKeyDown={handleKeyboardClick(onClick)}
        tabIndex="0"
      >
        <Image
          style={{ width: "100%", height: "auto" }}
          className={className}
          src={src}
          alt="carouselItem"
          aria-hidden="true"
        />
      </div>
    )
}


export default CarouselItem;